/* Outdoors Nordic. Flyttad ur snippets/on-cart-reviews.liquid 2026-10-07.
Lag inline och skickades med varje sidvisning som anvande sektionen.
Laddas som modul: samma URL evalueras en gang oavsett antal taggar. */
(function () {
if (customElements.get('on-cart-reviews')) return;
function initialsOf(name) {
var parts = (name || '').trim().split(/\s+/).filter(Boolean);
if (!parts.length) return '?';
if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}
function hueOf(str) { var h = 0, i; for (i = 0; i < (str || '').length; i++) { h = (h * 31 + str.charCodeAt(i)) % 360; } return h; }
function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
/* Datum pa besokarens sprak, med ar. Loox skickar ISO i r.date. */
function dateHTML(iso, lang) {
if (!iso) return '';
var d = new Date(iso);
if (isNaN(d)) return '';
var s;
try { s = d.toLocaleDateString(lang || 'sv', { year: 'numeric', month: 'short', day: 'numeric' }); }
catch (e) { s = d.toISOString().slice(0, 10); }
return '<time class="on-crv__date" datetime="' + esc(iso) + '">' + esc(s) + '</time>';
}
function starsHTML(r) { var pct = Math.max(0, Math.min(100, (r / 5) * 100)); return '<span class="on-crv__stars"><span class="on-crv__stars-base">★★★★★</span><span class="on-crv__stars-fill" style="width:' + pct + '%">★★★★★</span></span>'; }
var CHECK = '<svg viewBox="0 0 24 24" fill="#2d9cdb"><path d="M12 2a10 10 0 100 20 10 10 0 000-20zm-1.2 14.2l-4-4 1.4-1.4 2.6 2.6 5.6-5.6L17.8 9l-7 7.2z"/></svg>';
function mmCode(l) { l = (l || '').split('-')[0]; return (l === 'nb' || l === 'nn') ? 'no' : l; }
function seasonSets() {
var m = new Date().getMonth();
var COOL = ['sval', 'svalka', 'cool', 'kyl', 'andas', 'andning', 'breath', 'luftig', 'lätt', 'light', 'ademend', 'traspir', 'transpir', 'léger', 'leggero', 'ligero', 'lekki', 'sommar', 'summer', 'sommer', 'zomer', 'estate', 'verano', 'lato', 'verão', 'été', 'kesä'];
var WARM = ['varm', 'warm', 'värme', 'wärme', 'kall', 'cold', 'froid', 'kalt', 'koud', 'chaud', 'caldo', 'cálido', 'ciepł', 'snö', 'snow', 'neige', 'schnee', 'vinter', 'winter', 'invierno', 'inverno', 'hiver', 'talvi', 'zima', 'höst', 'autumn', 'herbst'];
if (m >= 5 && m <= 7) return { up: COOL, down: WARM };
if (m >= 11 || m <= 1) return { up: WARM, down: COOL };
if (m >= 2 && m <= 4) return { up: COOL, down: WARM };
return { up: WARM, down: COOL };
}
function seasonScore(text, sets) {
var t = (text || '').toLowerCase(), s = 0, i;
for (i = 0; i < sets.up.length; i++) { if (t.indexOf(sets.up[i]) > -1) { s += 2; break; } }
for (i = 0; i < sets.down.length; i++) { if (t.indexOf(sets.down[i]) > -1) { s -= 3; break; } }
return s;
}
// Delad observer för "Visa mer": mät texten NÄR den blir synlig (drawern öppnas).
var moreIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
entries.forEach(function (en) {
if (!en.isIntersecting) return;
var p = en.target;
moreIO.unobserve(p);
if (!p.parentNode || p.parentNode.querySelector('.on-crv__more')) return;
if (p.scrollHeight - p.clientHeight > 2) {
var host = p.closest('on-cart-reviews');
var more = (host && host.getAttribute('data-more')) || 'Read more';
var less = (host && host.getAttribute('data-less')) || 'Show less';
var b = document.createElement('button');
b.type = 'button'; b.className = 'on-crv__more'; b.textContent = more;
b.addEventListener('click', function () { var open = p.classList.toggle('is-open'); b.textContent = open ? less : more; });
p.parentNode.appendChild(b);
}
});
}) : null;
function renderAll() {
document.querySelectorAll('on-cart-reviews').forEach(function (el) { if (el.ensureRendered) el.ensureRendered(); });
}
class OnCartReviews extends HTMLElement {
connectedCallback() {
this.LANG = this.getAttribute('data-lang') || 'en';
this.TOKEN = this.getAttribute('data-token') || '';
this.COUNT = parseInt(this.getAttribute('data-count') || '3', 10);
this.MIN = parseFloat(this.getAttribute('data-min') || '4') || 0;
this.AVATAR = this.getAttribute('data-avatar') !== 'false';
this.INITIALS = this.getAttribute('data-initials') === 'true';
this.SEASONAL = this.getAttribute('data-seasonal') === 'true';
this.SUMMARY = this.getAttribute('data-summary') === 'true';
this.RWORD = this.getAttribute('data-reviews') || 'reviews';
this.AGGR = this.getAttribute('data-aggr') || '';
this.AGGT = this.getAttribute('data-aggt') || '';
this.VER = this.getAttribute('data-ver') || 'Verified buyer';
this.SORT = this.getAttribute('data-sort') || 'newest';
this.SHOWDATE = this.getAttribute('data-date') !== 'false';
/* id -> ISO ur Looxs egna feed-metafalt (API:t saknar land helt). */
this.FLAGS = {};
/* Slå ihop ALLA kartor (butiksfeed + en per produkt i varukorgen). */
var fsrcs = this.querySelectorAll('.on-rvflags');
var fjoin = [];
fsrcs.forEach(function (n) { fjoin.push(n.getAttribute('data-flags') || ''); });
fjoin.join(';').split(';').forEach(function (pair) {
var p = pair.split(':');
if (p.length === 2 && p[0] && p[1]) this.FLAGS[p[0]] = p[1];
}, this);
this.FLAGSVG = {};
var tpls = this.querySelectorAll('[data-rvflags]');
tpls.forEach(function (tp) { if (!tp.content) return; tp.content.querySelectorAll('i[data-code]').forEach(function (n) {
this.FLAGSVG[n.getAttribute('data-code')] = n.innerHTML;
}, this); }, this);
this.ensureRendered();
// Säkerhetsnät: om-kolla några gånger efter anslutning (morph/async-race).
var selfT = this;
[120, 500, 1200, 2500].forEach(function (t) { setTimeout(function () { selfT.ensureRendered(); }, t); });
// Rendera/mät när elementet blir synligt (drawern öppnas).
if (!this._visIO && 'IntersectionObserver' in window) {
var self = this;
this._visIO = new IntersectionObserver(function (entries) {
entries.forEach(function (en) { if (en.isIntersecting) self.ensureRendered(); });
});
this._visIO.observe(this);
}
// Globala triggers (en gång).
if (!window.__onCrvBound) {
window.__onCrvBound = true;
// Varukorgsändring (morph kan wipe:a listan) → om-rendera från cache flera gånger.
document.addEventListener('cart:update', function () { [150, 600, 1500].forEach(function (t) { setTimeout(renderAll, t); }); });
// Varukorgs-drawern är en native <dialog>. Att öppna den (showModal) fyrar INGET cart:update
// men Horizon kan om-rendera innehållet → listan wipe:as utan att våra andra triggers märker det.
// Superlätt observer på ENBART dialogens 'open'-attribut (ett attribut, ett element = ingen slowdown).
var bindDlg = function () {
document.querySelectorAll('.cart-drawer__dialog').forEach(function (dlg) {
if (dlg.__onCrvObs || !('MutationObserver' in window)) return;
dlg.__onCrvObs = true;
/* INP (prestanda 2026-10-15): bara nar ladan OPPNAS, och forsta kontrollen efter att
ladan har ritats. Forut kordes den 40 ms efter bade oppning och stangning, mitt i trycket. */
new MutationObserver(function () { if (!dlg.hasAttribute('open')) return; requestAnimationFrame(function () { setTimeout(renderAll, 0); }); [250, 700, 1400].forEach(function (t) { setTimeout(renderAll, t); }); }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
});
};
bindDlg();
setTimeout(bindDlg, 1000);
}
}
ensureRendered() {
this.list = this.querySelector('[data-crv-list]');
if (!this.list) return;
if (this.list.querySelector('.on-crv__card')) { this.wireMore(); this.bindScroller(); return; }
if (window.__onCrvData) { this.render(window.__onCrvData); return; }
if (window.__onCrvLoading) return;
if (!this.TOKEN) { this.list.innerHTML = '<div class="on-crv__state">Sätt Loox-id i temainställningarna.</div>'; return; }
this.load(0);
}
load(attempt) {
window.__onCrvLoading = true;
var self = this, pool = [], stats = {}, total = 0, avg = 0;
/* Lokala recensioner forst. Varukorgen visar bara ett par kort, sa de ska vara
pa besokarens eget sprak nar det finns sadana. Loox skickar originalLanguage
per recension; no/nb/nn raknas som samma sprak. */
var vLang = String(self.LANG || '').split('-')[0].toLowerCase();
function isNb(x) { return x === 'no' || x === 'nb' || x === 'nn'; }
function isLocal(r) {
var l = String(r.originalLanguage || r.language || '').split('-')[0].toLowerCase();
if (!l || !vLang) return false;
return l === vLang || (isNb(vLang) && isNb(l));
}
function localCount() { var c = 0; for (var i = 0; i < pool.length; i++) { if (isLocal(pool[i])) c++; } return c; }
function page(n) {
/* sort=date ger Loox NYASTE forst (verifierat: sida 1 = dagens datum,
utan parametern kom majrecensioner fran ifjol). Utan den syntes aldrig
nya recensioner i varukorgen, hur ofta de an kom in. limit=20 halvar
antalet anrop for samma urval. */
/* Loox svarar med cache-control: max-age=60, s-maxage=604800 - en
mellanliggande cache far alltsa behalla svaret i en VECKA. Utan detta
kunde varukorgen visa en gammal topplista aven med sort=date. Nyckeln
byts var tionde minut: farskt inom 10 min, men fortfarande cachat
inom fonstret sa vi inte hamrar API:t vid varje sidvisning. */
var bucket = Math.floor(Date.now() / 600000);
var url = 'https://storefront-api.loox.io/storefront/v1/store/' + self.TOKEN + '/product-reviews?limit=20&sort=date&page=' + n + '&_t=' + bucket;
return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }).then(function (data) {
if (n === 1) { stats = data.global_stats || {}; total = (data.pagination && data.pagination.total) || stats.total_reviews || stats.total || 0; avg = stats.avg_rating || stats.average || 0; }
(data.reviews || []).forEach(function (r) { if ((r.rating || 0) >= self.MIN && (r.body || '').trim().length > 2) pool.push(r); });
var more = data.pagination && data.pagination.hasMore;
/* Spara var vi ar i Loox paginering sa karusellen kan hamta fler
nar besokaren scrollar till slutet, i stallet for att ta hem allt
pa forhand (§1A). */
self.hasMore = !!more;
self.nextPage = n + 1;
/* Hamta bara sa mycket som behovs. Med sort=date racker forsta sidan
for de nyaste korten - tre anrop for 60 recensioner nar tre visas ar
ren sloseri (§1A). Sasongslaget poangsatter och behover storre pool. */
var need = self.SEASONAL ? 40 : Math.max((self.COUNT || 3) * 3, 9);
/* Rack inte forsta sidan till for besokarens sprak hamtar vi en sida till.
Pa en liten marknad kan de 20 nyaste vara helt utan lokala recensioner. */
var wantMore = pool.length < need || localCount() < (self.COUNT || 3);
if (more && n < 3 && wantMore) return page(n + 1);
});
}
page(1).then(function () {
var sets = self.SEASONAL ? seasonSets() : null;
pool.sort(function (a, b) {
if (sets) { var d = seasonScore(b.body, sets) - seasonScore(a.body, sets); if (d) return d; }
/* Nyast forst: da speglar varukorgen vad som faktiskt kommer in i Loox.
Hogst betyg forst gav alltid samma handfull femmor ur tusentals. */
if (self.SORT !== 'top') return new Date(b.date) - new Date(a.date);
return (b.rating - a.rating) || (new Date(b.date) - new Date(a.date));
});
/* Stabil uppdelning EFTER sorteringen: sasong och datum behalls inom
varje grupp, men besokarens sprak ligger overst. Finns inga lokala
faller listan tillbaka pa hela urvalet - inget goms. */
/* ENBART besokarens sprak. Tidigare lag lokala forst och resten efter,
men en svensk kund ska inte mota tyska recensioner i varukorgen alls.
Finns det INGEN pa spraket visas hela urvalet - annars hade blocket
tomts helt pa en ny marknad, vilket ar samre an fel sprak. */
var locHit = [];
for (var li = 0; li < pool.length; li++) { if (isLocal(pool[li])) locHit.push(pool[li]); }
if (locHit.length) pool = locHit;
/* ALLA kort ska ha landsflagga. Loox API skickar inget land, sa vi visar
bara recensioner som finns i feed-kartan. Ger kartan inga alls faller vi
tillbaka pa sprakurvalet - hellre kort utan flagga an en tom remsa. */
var flagged = [];
for (var fi = 0; fi < pool.length; fi++) { if (self.FLAGS[pool[fi].id]) flagged.push(pool[fi]); }
if (flagged.length) pool = flagged;
/* Hela poolen sparas: forsta omgangen visas direkt, resten laggs till
nar man scrollar. Tidigare kastades overskottet och remsan tog slut
efter "Antal recensioner". */
self.pool = pool;
self.rendered = Math.min(pool.length, self.COUNT || 3);
/* Poolen och paginering ligger GLOBALT: pa varukorgssidan finns tva
on-cart-reviews (sidan + ladan) men bara EN kor load(). Las de har
fran instansen och den andra hittade ingen pool att fylla pa med. */
window.__onCrvData = { list: pool.slice(0, self.COUNT), pool: pool, total: total, avg: avg, hasMore: !!self.hasMore, nextPage: self.nextPage || 2 };
window.__onCrvLoading = false;
renderAll();
}).catch(function () {
window.__onCrvLoading = false;
if ((attempt || 0) < 1) { setTimeout(function () { self.load(1); }, 1200); }
else { document.querySelectorAll('on-cart-reviews').forEach(function (el) { var l = el.querySelector('[data-crv-list]'); if (!l || !l.querySelector('.on-crv__card')) el.style.display = 'none'; }); }
});
}
/* Kortets HTML som egen metod: render() bygger forsta omgangen och
kortet ritas pa exakt ett stalle sa alla kort ser likadana ut. */
cardHTML(r) {
var self = this;
var name = (r.reviewer && r.reviewer.name) || '';
var ava = '';
if (self.AVATAR) {
var photo = r.avatar || (r.reviewer && r.reviewer.avatar) || '';
if (photo) ava = '<img class="on-crv__ava" src="' + esc(photo) + '" alt="" loading="lazy">';
else if (self.INITIALS) ava = '<span class="on-crv__ini" style="background:hsl(' + hueOf(name) + ',42%,42%)">' + esc(initialsOf(name)) + '</span>';
else ava = '<span class="on-crv__ini" style="background:var(--on-brand, #004E20)">' + esc(initialsOf(name)) + '</span>';
}
var ol = String(r.originalLanguage || r.language || '').split('-')[0].toLowerCase();
var fiso = self.FLAGS[r.id];
var flag = fiso && self.FLAGSVG[fiso] ? '<span class="on-crv__flag" title="' + esc(fiso) + '">' + self.FLAGSVG[fiso] + '</span>' : '';
/* Samma korstruktur som recensionsfliken i on-product-tabs: namnrad,
stjarnor, text. Avataren ligger i namnraden i stallet
for som egen kolumn - annars blir det en annan design, inte samma. */
return '<div class="on-crv__card" data-from="' + esc(mmCode(ol)) + '">' +
'<div class="on-crv__row">' + ava + flag + '<span class="on-crv__name">' + esc(name) + '</span>' +
(r.verified ? '<span class="on-crv__vrf">' + CHECK + '<span>' + esc(self.VER) + '</span></span>' : '') + '</div>' +
'<div class="on-crv__meta">' + starsHTML(r.rating || 5) +
(self.SHOWDATE ? dateHTML(r.date, self.LANG) : '') + '</div>' +
'<p class="on-crv__text">' + esc(r.body) + '</p>' +
'</div>';
}
render(data) {
this.list = this.querySelector('[data-crv-list]');
if (!this.list) return;
var self = this, list = (data && data.list) || [];
if (!list.length) { this.style.display = 'none'; return; }
this.style.display = '';
this.list.innerHTML = list.map(function (r) { return self.cardHTML(r); }).join('');
if (this.SUMMARY) {
var aggEl = this.querySelector('[data-crv-agg]');
if (aggEl) {
var avg = parseFloat(data.avg) || parseFloat(this.AGGR) || 0;
var total = data.total || 0;
if (avg > 0) {
var pct = Math.max(0, Math.min(100, (avg / 5) * 100));
var txt = total > 0 ? (total.toLocaleString(this.LANG) + ' ' + this.RWORD) : this.AGGT;
aggEl.innerHTML = '<span class="on-crv__agg-stars"><span class="on-crv__agg-base">★★★★★</span><span class="on-crv__agg-fill" style="width:' + pct + '%">★★★★★</span></span>' +
'<span class="on-crv__agg-num">' + (Math.round(avg * 10) / 10).toString().replace('.', ',') + '</span>' +
(txt ? '<span class="on-crv__agg-txt">' + esc(txt) + '</span>' : '');
aggEl.hidden = false;
}
}
}
this.fitCards();
this.wireMore();
this.bindScroller();
}
// Registrera texterna hos observern → "Visa mer" läggs till när de blir synliga.
/* Datorvy: overflow-x racker inte - mushjulet scrollar sidan och det finns
inget att dra i. Samma losning som recensionsfliken pa produktsidan:
pekaren fangas FORST efter 4 px rorelse, annars byter det efterfoljande
klicket maltavla till behallaren och Oversatt-knappen slutar fungera. */
/* Fler kort nar man scrollar till slutet av remsan. Forst ur poolen som redan
hamtats, sedan nasta Loox-sida. Taket pa 60 kort finns for att en karusell i
varukorgen inte ska vaxa obegransat och ata huvudtraden (§1A). */
/* Ett HELT antal kort plus en jamn titt (40px) pa nasta, oavsett om remsan star i
den smala ladan eller pa den breda sidan. Rakna, satt, klart - inga brytpunkter
mot fonsterbredden, for behallaren och fonstret ar inte samma sak har. */
fitCards() {
var el = this.list;
if (!el) return;
var w = el.clientWidth;
/* Bara EN gard mot upprepning nar bredden ar densamma - men aldrig sa att
en for liten bredd hinner sparas som "redan raknad". */
if (w >= 200 && w === this.lastFitWidth) return;
/* En behallare under 200px ar inte fardiglayoutad (ladan stangd, sidan mitt
i rendering). Skulle vi rakna da last en orimlig kortbredd fast. */
if (w < 200) return;
this.lastFitWidth = w;
var gap = 10, peek = 40, minW = 230, maxW = 340;
var n = Math.max(1, Math.floor((w - peek + gap) / (minW + gap)));
var card = (w - peek - gap * n) / n;
if (card > maxW) {
n = Math.max(1, Math.ceil((w - peek + gap) / (maxW + gap)));
card = (w - peek - gap * n) / n;
}
card = Math.max(200, card);
if (!(card > 0)) return;
el.style.setProperty('--on-crv-card', Math.floor(card) + 'px');
}
bindScroller() {
var el = this.list;
if (!el || el.dataset.scrollBound) return;
el.dataset.scrollBound = '1';
/* Bredden raknas om nar ytan andras - ladan oppnas, telefonen vands. */
var fitHost = this;
/* Ladan renderar remsan medan den ar STANGD - da ar bredden 0 och matningen
hoppar av, sa korten foll tillbaka pa standardbredden och blev halva nar
ladan oppnades. Rakna om nar dialogen vaxlar och strax darefter. */
var dlg = this.closest('dialog');
if (dlg) {
dlg.addEventListener('toggle', function () {
/* Matningen tvingar fram layout av hela ladan: forst efter att ladan har ritats, och
inte alls nar den stangs (prestanda 2026-10-15). */
if (!dlg.open) return;
requestAnimationFrame(function () { setTimeout(function () { fitHost.fitCards(); }, 0); });
[120, 400].forEach(function (t) { setTimeout(function () { fitHost.fitCards(); }, t); });
});
}
window.addEventListener('resize', function () { fitHost.fitCards(); }, { passive: true });
var down = false, moved = false, x0 = 0, s0 = 0, pid = null;
el.addEventListener('pointerdown', function (e) {
/* Mobilen ska scrolla NATIVT. Kapar vi touch-pekaren (setPointerCapture +
preventDefault) forsvinner webblasarens momentum och det kanns tragt -
precis den skillnad som gjorde att flikarnas remsa kandes mjuk och
varukorgens inte. Dragningen har ar bara till for mus. */
if (e.pointerType === 'touch') return;
if (e.button !== 0) return;
down = true; moved = false; x0 = e.clientX; s0 = el.scrollLeft; pid = e.pointerId;
});
el.addEventListener('pointermove', function (e) {
if (!down) return;
var dx = e.clientX - x0;
if (!moved && Math.abs(dx) < 4) return;
if (!moved) { moved = true; el.classList.add('is-dragging'); try { el.setPointerCapture(pid); } catch (err) {} }
el.scrollLeft = s0 - dx;
e.preventDefault();
});
function up() { down = false; if (moved) { setTimeout(function () { el.classList.remove('is-dragging'); }, 0); } moved = false; }
el.addEventListener('pointerup', up);
el.addEventListener('pointercancel', up);
el.addEventListener('pointerleave', up);
/* Lodratt hjul oversatts till sidled, men bara sa lange det finns kvar att
scrolla - annars laser karusellen fast hela sidans scroll. */
el.addEventListener('wheel', function (e) {
if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
var max = el.scrollWidth - el.clientWidth;
if (max <= 0) return;
var next = el.scrollLeft + e.deltaY;
if (next < 0 || next > max) return;
el.scrollLeft = next;
e.preventDefault();
}, { passive: false });
}
wireMore() {
if (!this.list) return;
this.list.querySelectorAll('.on-crv__text').forEach(function (p) {
if (p.parentNode && p.parentNode.querySelector('.on-crv__more')) return;
if (p.dataset.moObs) return;
p.dataset.moObs = '1';
if (moreIO) { moreIO.observe(p); }
else if (p.scrollHeight - p.clientHeight > 2) {
var host = p.closest('on-cart-reviews');
var more = (host && host.getAttribute('data-more')) || 'Read more';
var less = (host && host.getAttribute('data-less')) || 'Show less';
var b = document.createElement('button');
b.type = 'button'; b.className = 'on-crv__more'; b.textContent = more;
b.addEventListener('click', function () { var open = p.classList.toggle('is-open'); b.textContent = open ? less : more; });
p.parentNode.appendChild(b);
}
});
}
}
customElements.define('on-cart-reviews', OnCartReviews);
})();
